import React from "react";
import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar as CalIcon, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

export function DatePicker({ value, onChange, placeholder = "jj/mm/aaaa", testid, clearable = true }) {
  const selected = value ? parseISO(value) : undefined;
  const [open, setOpen] = React.useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className="flex w-full items-center justify-between rounded-lg border border-slate-200 bg-white px-2 py-2 text-sm outline-none transition-colors duration-150 hover:border-slate-300 focus:border-slate-400">
          <span className={value ? "text-slate-900" : "text-slate-400"}>{value ? format(selected, "dd/MM/yyyy") : placeholder}</span>
          <span className="flex items-center gap-1">
            {value && clearable && (
              <X data-testid={testid ? `${testid}-clear` : undefined} className="h-3.5 w-3.5 text-slate-400 hover:text-slate-700" onClick={(e) => { e.stopPropagation(); onChange(""); }} />
            )}
            <CalIcon className="h-4 w-4 text-slate-400" />
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={fr} selected={selected} onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
